import { CATEGORIES_DOMAIN } from 'modules/categories/constants'
import getDomainMapKeyFromPathReduxUtil from 'modules/redux/utils/get-domain-map-key-from-path'
import getDomainPathFromSectionReduxUtil from 'modules/redux/utils/get-domain-path-from-section'
import getDomainMapValueFromPathRouteUtil from 'modules/routes/utils/get-domain-map-value-from-path'
import { logUtil } from 'packages/src'

/**
 * Gets an instance path from the store matching the given route.
 * @param  {Object} route
 * @param  {Object} match
 * @returns {string}
 */
function getPathFromRouteAndMatchReduxUtil (route, match) {
  const {
    section,
    path
  } = route

  // Get the domain map key
  const domainPath = getDomainPathFromSectionReduxUtil(section)
  const domainMapKey = getDomainMapKeyFromPathReduxUtil(domainPath)
  const domainValue = (
    match.params[domainMapKey] ||
    getDomainMapValueFromPathRouteUtil(path)
  )

  const debugProps = {
    domainPath,
    domainMapKey,
    domainValue
  }
  logUtil('getPathFromRouteAndMatchReduxUtil').debug('debugProps=', debugProps)

  if (
    domainPath === CATEGORIES_DOMAIN ||
    !domainValue
  ) {
    let { category } = match.params
    category = category || 'all'
    return `${CATEGORIES_DOMAIN}.${section}.data.${category}`
  }

  return `${domainPath}.data.${domainValue}`
}

export default getPathFromRouteAndMatchReduxUtil
